import App from 'src/App'
import { discoverRoutes } from 'src/pages/DiscoverPage/discover-routes'
import { tradeRoutes } from 'src/pages/TradePage/trade-routes'
import UiDev from 'src/pages/UiDev'
import { createBrowserRouter, Navigate } from 'react-router-dom'
import staticConfig from 'src/config'
import { walletRoutes } from 'src/pages/WalletPage/wallet-routes'

const isDevMode = staticConfig.isDevMode

export const pageRoutes = [tradeRoutes, discoverRoutes, walletRoutes]
export const navbarRoutes = [
  {
    path: '/trade/invest',
    name: 'Invest',
  },
  {
    path: '/trade/swap',
    name: 'Trade',
    activePaths: ['/trade/swap', '/trade/limit'],
  },
  { path: '/discover', name: 'Discover' },
  { path: '/wallet', name: 'Wallet' },
]

export const appRoutes = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      { index: true, element: <Navigate to='trade/invest' replace /> },
      ...pageRoutes,
      { path: '*', element: <Navigate to='trade/invest' replace /> },
    ],
  },
  isDevMode
    ? {
        path: '/ui-dev',
        element: <UiDev />,
      }
    : {},
])
